"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageActivity = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const silhouette_core_1 = require("@freighthub/silhouette-core");
exports.testIds = {
    messageWrapper: 'activity_feed-message_wrapper',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        background: theme.palette.background.default,
        fontStyle: 'italic',
        whiteSpace: 'pre-line',
        wordBreak: 'break-word',
        borderRadius: 8,
    },
}));
const MessageActivity = ({ activity }) => {
    const classes = useStyles();
    if (!activity.content) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { p: 2, className: classes.container, "data-testid": exports.testIds.messageWrapper, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", children: activity.content }) }));
};
exports.MessageActivity = MessageActivity;
//# sourceMappingURL=MessageActivity.js.map